/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAppsQueryVariables = Types.Exact<{
  productTypes?: Types.InputMaybe<Array<Types.AppProductTypeEnum> | Types.AppProductTypeEnum>;
  certificationTypes?: Types.InputMaybe<Array<Types.AppCertificationTypeEnum> | Types.AppCertificationTypeEnum>;
  unclaimed?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  unreadTasksExist?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  needsFinishing?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  productsExist?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  owned?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type IAppsQuery = {
  __typename?: 'Query';
  apps: {
    __typename?: 'AppPage';
    nodesCount: number;
    pagesCount: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    nodes: Array<{
      __typename?: 'App';
      kind: Types.AppKindEnum;
      id: string;
      name?: string | null;
      criticality?: Types.AppCriticalityEnum | null;
      unclaimed: boolean;
      owned: boolean;
      ownerName: string;
      logoUrl?: string | null;
      taskCounts: Array<{ __typename?: 'TaskCount'; criticality: Types.TaskCriticalityEnum; count: number }>;
      policy: { __typename?: 'AppPolicy'; update: boolean; remove: boolean };
    }>;
  };
};

export const AppsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'apps' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppProductTypeEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'certificationTypes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AppCertificationTypeEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unclaimed' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unreadTasksExist' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'needsFinishing' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'productsExist' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'owned' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'apps' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'certificationTypes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'certificationTypes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unclaimed' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'unclaimed' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unreadTasksExist' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'unreadTasksExist' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'needsFinishing' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'needsFinishing' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'productsExist' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'productsExist' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'owned' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'owned' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AppBaseFields' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AppBaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'App' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unclaimed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'owned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ownerName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'taskCounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'criticality' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAppsQuery, IAppsQueryVariables>;
